import { AppSubdomains } from 'src/types/common';
import AuthProtectedRoute from './AuthProtectedRoute';
import SubdomainProtectedRoute from './SubdomainProtectedRoute';

interface ProtectedRouteProps {
  children: React.ReactNode;
  disableAuthProtection?: boolean;
  includedSubdomains?: AppSubdomains[];
  excludedSubdomains?: AppSubdomains[];
  expectedAuthState?: 'authenticated' | 'non-authenticated';
}

function ProtectedRoute({
  children,
  disableAuthProtection = false,
  includedSubdomains,
  excludedSubdomains,
  expectedAuthState = 'authenticated',
}: ProtectedRouteProps) {
  let content = children;

  if (includedSubdomains || excludedSubdomains) {
    content = (
      <SubdomainProtectedRoute
        includedSubdomains={includedSubdomains}
        excludedSubdomains={excludedSubdomains}
      >
        {content}
      </SubdomainProtectedRoute>
    );
  }

  if (!disableAuthProtection) {
    content = (
      <AuthProtectedRoute expectedAuthState={expectedAuthState}>
        {content}
      </AuthProtectedRoute>
    );
  }

  return content;
}

export default ProtectedRoute;
